// AbtSliceSchema.ts

import {
    ABTestExpandedSchema,
    LsRewardUnitEnum,
    validators,
} from "@bridge-applications/eh-types";
import { z } from "zod";

export const AbtSliceSchema = z.object({
    isSkeletonRendering: z.boolean(),
    abTests: z.array(ABTestExpandedSchema),
    myAbTests: z.array(ABTestExpandedSchema),
    availableRewards: z.object({
        count: z.number().int(),
        lastClaimedAt: validators.timestampMs().nullable(),
        canClaimAt: validators.timestampMs().nullable(),
        breakdown: z.array(
            z.object({
                unit: z.enum(LsRewardUnitEnum),
                humanAmount: z.string(),
            }),
        ),
    }),
});
